export class Navigate {
    static readonly type = "[Router] Navigate";
    constructor(public payload: string[]) {}
}

export class NavigationExtras {
    static readonly type = "[Router] Navigation extras";
    constructor(public payload: string) {}
}
